import { IWorkspace } from './workspace';

export type IPlan = {
  _id: string;
  name: string;
  order: number;
  free?: boolean;
  monthlyPrice: number;
  yearlyPrice: number;
  features: string[];
  trialDays?: number;
};

export enum BillingStatus {
  ACTIVE = 'active',
  PAUSED = 'paused',
  TRIAL = 'trialing',
  TRIAL_WILL_END = 'trial_will_end',
}

export type BillingInfo = {
  _id: string;
  workspace: IWorkspace;
  plan: IPlan;
  cards: ICard[];
  status: BillingStatus;
  trial_end?: string;
  next_renew?: string;
  last_change?: string;
  customerId?: string;
  subscriptionId?: string;
  members: {
    _id: string;
  }[];
  createdAt: string;
  updatedAt: string;
  invoices: IBillingInvoice[];
  subscription?: {
    created: number;
    currency: string;
    current_period_end: number;
    current_period_start: number;
    discount?: {
      start: number;
      end: number | null;
      coupon?: {
        id: string;
        amount_off: number | null;
        percent_off: number;
        times_redeemed: number;
        currency: string | null;
      };
    };
    latest_invoice: string;
    quantity: number;
    start_date: number;
    status: string;
  };
  billableSeats: number;
};

export type ICard = {
  _id: string;
  default: boolean;
  workspace: string;
  card: string;
  name: string;
  exp_month: string;
  exp_year: string;
  brand?: string;
  token: string;
  createdAt: string;
  updatedAt: string;
};

export type IBillingInvoice = {
  created: number;
  id: string;
  invoice_pdf: string;
  status: string;
  total: number;
};
